import React from "react";
import Profile from "../../assets/perfil.png";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./home.css";

const Home = () => {
  return (
    <section className="home section grid">
      <img src={Profile} alt="" className="home__img" />

      <div className="home__content">
        <div className="home__data">
          <h1 className="home__title">
            Eu sou o Agostinho Soberano!
            <span>Desenvolvedor Full Stack | Empreendedor Tech</span>
          </h1>
          <p className="home__description">
            Estudante finalista de Engenharia Informática e Telecomunicações
            pela Universidade Politécnica, com sólida experiência prática em
            desenvolvimento full stack, redes de computadores, configuração de
            servidores VPS e criação de sistemas empresariais (ERP e GPS
            Tracking). Co-fundador da CODE GENIUS, LDA, onde atuo como
            desenvolvedor principal, participando desde a concepção,
            planeamento, desenvolvimento e implementação de soluções
            tecnológicas completas..
          </p>

          <Link to="/sobre" className="button">
            Mais sobre mim{" "}
            <span className="button__icon">
              <FaArrowRight />
            </span>
          </Link>
        </div>
      </div>

      <div className="color__block"></div>
    </section>
  );
};

export default Home;
